'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Label = exports.FieldInlineWrapper = exports.FieldWrapper = exports.StyledItem = exports.getStyle = undefined;

var _contains2 = require('ramda/src/contains');

var _contains3 = _interopRequireDefault(_contains2);

var _path2 = require('ramda/src/path');

var _path3 = _interopRequireDefault(_path2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    ', '\n\n    margin: 0;\n    padding: 0.5rem;\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n    background: ', '\n    ', '\n    ', '\n\n    &.field-error {\n        ', '\n    }\n'], ['\n    ', '\n\n    margin: 0;\n    padding: 0.5rem;\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n    background: ', '\n    ', '\n    ', '\n\n    &.field-error {\n        ', '\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['', ''], ['', '']),
    _templateObject3 = _taggedTemplateLiteral(['\n    position: relative;\n    ', ': ', '%;\n    display: ', ';\n    padding-right: ', ';\n    @media (max-width: 756px) {\n        width: 100%;\n    }\n'], ['\n    position: relative;\n    ', ': ', '%;\n    display: ', ';\n    padding-right: ', ';\n    @media (max-width: 756px) {\n        width: 100%;\n    }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    ', '\n    position: relative;\n    ', ': calc(', '% - ', ');\n    margin-right: ', ';\n    margin-bottom: 8px;\n    display: inline-block;\n    text-align: left;\n    vertical-align: top;\n    @media (max-width: 756px) {\n        width: 100%;\n    }\n\n    &.field-error {\n        ', '\n    }\n'], ['\n    ', '\n    position: relative;\n    ', ': calc(', '% - ', ');\n    margin-right: ', ';\n    margin-bottom: 8px;\n    display: inline-block;\n    text-align: left;\n    vertical-align: top;\n    @media (max-width: 756px) {\n        width: 100%;\n    }\n\n    &.field-error {\n        ', '\n    }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    width: 100%;\n    max-width: calc(100% - 340px);\n    min-width: 110px;\n    float: left;\n    position: relative;\n'], ['\n    width: 100%;\n    max-width: calc(100% - 340px);\n    min-width: 110px;\n    float: left;\n    position: relative;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n    color: #e94f34;\n    display: block;\n    margin-top: 5px;\n    cursor: default;\n\n    display: flex;\n    justify-content: flex-start;\n\n    ', '\n\n    svg {\n        display: inline-block;\n        font-style: normal;\n        font-variant: normal;\n        text-rendering: auto;\n        line-height: 1;\n        margin-top: 2px;\n        margin-right: 4px;\n        font-size: 14px;\n    }\n'], ['\n    color: #e94f34;\n    display: block;\n    margin-top: 5px;\n    cursor: default;\n\n    display: flex;\n    justify-content: flex-start;\n\n    ', '\n\n    svg {\n        display: inline-block;\n        font-style: normal;\n        font-variant: normal;\n        text-rendering: auto;\n        line-height: 1;\n        margin-top: 2px;\n        margin-right: 4px;\n        font-size: 14px;\n    }\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n    color: #f5222d;\n    margin-top: 5px;\n    display: block;\n'], ['\n    color: #f5222d;\n    margin-top: 5px;\n    display: block;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n    box-sizing: border-box;\n    white-space: normal;\n    margin-bottom: 4px;\n    display: inline-block;\n    padding-right: 8px;\n    vertical-align: top;\n    text-align: right;\n    padding-top: 8px;\n    &::before {\n        content: ', ';\n        color: #f5222d;\n        margin-right: 4px;\n    }\n    width: ', '%;\n    @media (max-width: 756px) {\n        width: 100%;\n    }\n'], ['\n    box-sizing: border-box;\n    white-space: normal;\n    margin-bottom: 4px;\n    display: inline-block;\n    padding-right: 8px;\n    vertical-align: top;\n    text-align: right;\n    padding-top: 8px;\n    &::before {\n        content: ', ';\n        color: #f5222d;\n        margin-right: 4px;\n    }\n    width: ', '%;\n    @media (max-width: 756px) {\n        width: 100%;\n    }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _fa = require('react-icons/fa');

var _tooltip = require('antd/lib/tooltip');

var _tooltip2 = _interopRequireDefault(_tooltip);

var _reactFinalForm = require('react-final-form');

var _experiumPlayerHelpers = require('experium-player-helpers');

require('antd/lib/tooltip/style/index.css');

var _Wrapper = require('../../context/Wrapper');

var _Text = require('../textComponents/Text');

var _Text2 = _interopRequireDefault(_Text);

var _WorkExperience = require('../functions/WorkExperience');

var _WorkExperience2 = _interopRequireDefault(_WorkExperience);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getStyle = exports.getStyle = function getStyle(css) {
    var className = css ? css.match('class="([^"]*)')[1] : null;
    var style = css ? css.match('style="([^"]*)')[1] : '';

    return {
        className: className,
        style: style
    };
};

var requiredStyle = '\n    input, textarea, div.ant-select > div.ant-select-selector, div.ant-select.ant-select-single > div.ant-select-selector {\n        border-color: #e94f34;\n    }\n\n    input[type=\'checkbox\'] {\n        box-shadow: 0 0 0 0 transparent inset, 0 0 0 0 transparent inset, 0 0 0 1px #e94f34 inset, 0 0 0 0 transparent;\n    }\n';

var StyledItem = exports.StyledItem = _styledComponents2.default.div(_templateObject, function (props) {
    return (0, _styledComponents.css)(_templateObject2, props.cssStyle);
}, function (_ref) {
    var background = _ref.background;
    return background ? '#f8f9f9' : 'transparent';
}, function (_ref2) {
    var inline = _ref2.inline;
    return inline ? 'padding-bottom: 0' : '';
}, function (_ref3) {
    var hasAdditional = _ref3.hasAdditional;
    return hasAdditional ? 'padding-top: 32px' : '';
}, requiredStyle);

var FieldWrapper = exports.FieldWrapper = _styledComponents2.default.div(_templateObject3, function (_ref4) {
    var isDate = _ref4.isDate;
    return isDate ? 'max-width' : 'width';
}, function (_ref5) {
    var vertical = _ref5.vertical,
        width = _ref5.width;
    return vertical ? width || 100 : width ? Math.min((width * 80 / 100).toFixed(0), 80) : 80;
}, function (_ref6) {
    var vertical = _ref6.vertical;
    return vertical ? 'block' : 'inline-block';
}, function (_ref7) {
    var subField = _ref7.subField;
    return subField ? '0' : '10px';
});

var FieldInlineWrapper = exports.FieldInlineWrapper = _styledComponents2.default.div(_templateObject4, function (props) {
    return (0, _styledComponents.css)(_templateObject2, props.cssStyle);
}, function (_ref8) {
    var isDate = _ref8.isDate;
    return isDate ? 'max-width' : 'width';
}, function (_ref9) {
    var width = _ref9.width;
    return width ? width : 100;
}, function (_ref10) {
    var tooltip = _ref10.tooltip;
    return tooltip ? '30px' : '10px';
}, function (_ref11) {
    var tooltip = _ref11.tooltip;
    return tooltip ? '30px' : '10px';
}, requiredStyle);

var WorkFunctionField = _styledComponents2.default.div(_templateObject5);

var Specification = _styledComponents2.default.div(_templateObject6, function (_ref12) {
    var tooltip = _ref12.tooltip;
    return tooltip ? '\n        position: absolute;\n        top: -5px;\n        right: -22px;\n    ' : '';
});

var Error = _styledComponents2.default.span(_templateObject7);

var Label = exports.Label = _styledComponents2.default.span(_templateObject8, function (_ref13) {
    var required = _ref13.required;
    return required ? '"*"' : null;
}, function (_ref14) {
    var vertical = _ref14.vertical;
    return vertical ? 100 : 20;
});

var SpecificationComponent = function SpecificationComponent(_ref15) {
    var item = _ref15.item,
        language = _ref15.language;

    var options = (0, _react.useContext)(_Wrapper.WrapperContext);
    var tooltip = (0, _path3.default)(['specification', 'tooltip'], item);
    var specification = (0, _experiumPlayerHelpers.getText)(item, language, 'specification');

    return specification && options.showSpecification ? _react2.default.createElement(
        Specification,
        { tooltip: tooltip },
        _react2.default.createElement(
            _tooltip2.default,
            { title: tooltip ? _react2.default.createElement(_Text2.default, { text: specification }) : false, placement: 'left' },
            _react2.default.createElement(_fa.FaInfoCircle, null)
        ),
        tooltip ? null : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_Text2.default, { text: specification })
        )
    ) : null;
};

SpecificationComponent.propTypes = {
    item: _propTypes2.default.object,
    language: _propTypes2.default.string
};

exports.default = function (WrappedComponent) {
    var _class, _temp2;

    return _temp2 = _class = function (_Component) {
        _inherits(_class, _Component);

        function _class() {
            var _ref16;

            var _temp, _this, _ret;

            _classCallCheck(this, _class);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref16 = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref16, [this].concat(args))), _this), _this.onChange = function (value) {
                var _this$props = _this.props,
                    type = _this$props.type,
                    _this$props$input = _this$props.input,
                    onChange = _this$props$input.onChange,
                    inputType = _this$props$input.type,
                    originValue = _this$props$input.value;


                onChange({ type: type || inputType, value: value, '#index': (0, _path3.default)(['#index'], originValue) });
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(_class, [{
            key: 'render',
            value: function render() {
                var _this2 = this;

                var _props = this.props,
                    additional = _props.additional,
                    language = _props.language,
                    item = _props.item,
                    parent = _props.parent,
                    meta = _props.meta,
                    _props$input = _props.input,
                    _props$input$value = _props$input.value,
                    value = _props$input$value === undefined ? {} : _props$input$value,
                    type = _props$input.type,
                    vertical = _props.vertical,
                    inline = _props.inline,
                    isLast = _props.isLast;

                var css = getStyle(item.css);
                var labelText = (0, _experiumPlayerHelpers.getText)(item, language) || '';
                var tooltip = (0, _path3.default)(['specification', 'tooltip'], item);
                var isDate = !item.mask && (0, _contains3.default)(type, ['date', 'month_year', 'year']) && !parent;
                var hasWorkFunction = (0, _path3.default)(['function'], this.props.parent) === 'calc_work_experience';
                var hasFunctionTag = (0, _path3.default)(['function_tag'], this.props.item) === 'to';

                var _$split = ('' + (item.id || '')).split('['),
                    _$split2 = _slicedToArray(_$split, 1),
                    parentName = _$split2[0];

                var isRequired = !!meta.error;
                var showErr = meta.error && meta.submitFailed ? meta.error !== 'required' : false;
                var maxWidth = (0, _path3.default)(['answer_width_percent'], parent) || 100;

                return inline ? _react2.default.createElement(
                    FieldInlineWrapper,
                    {
                        cssStyle: css.style,
                        className: 'field-wrapper-inline ' + (css.className || '') + ' ' + (isRequired ? 'field-error' : ''),
                        isDate: isDate,
                        singleTable: !!(0, _path3.default)(['single'], item),
                        width: (0, _path3.default)(['answer_width_percent'], item) ? (0, _path3.default)(['answer_width_percent'], item) / 100 * maxWidth : maxWidth / (Number(inline) || 1),
                        error: showErr,
                        tooltip: tooltip,
                        isLast: isLast
                    },
                    additional || null,
                    WrappedComponent && _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
                        label: (0, _experiumPlayerHelpers.getPlaceholder)(labelText),
                        onChange: this.onChange,
                        value: value.value
                    })),
                    _react2.default.createElement(SpecificationComponent, { item: item, language: language })
                ) : _react2.default.createElement(
                    StyledItem,
                    {
                        cssStyle: css.style,
                        className: 'styled-item ' + (css.className || '') + ' ' + (isRequired ? 'field-error' : ''),
                        error: showErr,
                        background: (0, _path3.default)(['background'], item),
                        hasAdditional: !!additional
                    },
                    _react2.default.createElement(
                        Label,
                        { vertical: vertical },
                        labelText && _react2.default.createElement(_Text2.default, { text: labelText })
                    ),
                    _react2.default.createElement(
                        FieldWrapper,
                        {
                            vertical: vertical,
                            className: 'field-wrapper',
                            width: (0, _path3.default)(['answer_width_percent'], item) || (0, _path3.default)(['answer_width_percent'], parent),
                            tooltip: tooltip
                        },
                        hasFunctionTag && hasWorkFunction ? _react2.default.createElement(
                            _react.Fragment,
                            null,
                            _react2.default.createElement(
                                WorkFunctionField,
                                null,
                                additional || null,
                                WrappedComponent && _react2.default.createElement(WrappedComponent, _extends({}, this.props, { onChange: this.onChange, value: value.value })),
                                showErr && _react2.default.createElement(
                                    Error,
                                    null,
                                    _react2.default.createElement(_experiumPlayerHelpers.FormattedMessage, { id: meta.error })
                                ),
                                _react2.default.createElement(SpecificationComponent, { item: item, language: language })
                            ),
                            _react2.default.createElement(
                                _reactFinalForm.Field,
                                { name: parentName },
                                function (_ref17) {
                                    var input = _ref17.input;
                                    return _react2.default.createElement(_WorkExperience2.default, {
                                        items: parent.items,
                                        index: _this2.props.subIndex,
                                        value: (0, _path3.default)(['value', _this2.props.subIndex], input),
                                        values: (0, _path3.default)(['value'], input) || [],
                                        long: true
                                    });
                                }
                            )
                        ) : _react2.default.createElement(
                            _react.Fragment,
                            null,
                            additional || null,
                            WrappedComponent && _react2.default.createElement(WrappedComponent, _extends({}, this.props, { onChange: this.onChange, value: value.value })),
                            showErr && _react2.default.createElement(
                                Error,
                                null,
                                _react2.default.createElement(_experiumPlayerHelpers.FormattedMessage, { id: meta.error })
                            ),
                            _react2.default.createElement(SpecificationComponent, { item: item, language: language })
                        )
                    )
                );
            }
        }]);

        return _class;
    }(_react.Component), _class.displayName = 'FieldWrapper', _class.propTypes = {
        item: _propTypes2.default.object,
        parent: _propTypes2.default.object,
        required: _propTypes2.default.bool,
        language: _propTypes2.default.string,
        vertical: _propTypes2.default.bool,
        isLast: _propTypes2.default.bool,
        inline: _propTypes2.default.number,
        type: _propTypes2.default.string,
        subIndex: _propTypes2.default.number,
        input: _propTypes2.default.object.isRequired,
        meta: _propTypes2.default.object.isRequired,
        additional: _propTypes2.default.node
    }, _temp2;
};